import React from 'react';
import classnames from 'classnames';

import styles from './Button.module.scss';

interface ButtonProps extends ClickableElementProps {
  /** @boolean - Button element disabled status */
  disabled?: boolean;
  /** @function - Called when button is clicked */
  onClick?: (e?: any) => void;
  /** @function - Called when the mouse cursor enters the button */
  onMouseEnter?: () => void;
  /** @string - Button tooltip text */
  tooltipText?: string;
  type?:
    | string
    | 'Default'
    | 'Outline'
    | 'Cancel'
    | 'Input'
    | 'Primary'
    | 'Delete'
    | 'Plain'
    | 'Pill'
    | 'Chiclet'
    | 'Icon'
    | 'Integration'
    | 'Flat'
    | 'Simple'
    | 'Special'
    | 'Utility';
}

const Button: React.FC<ButtonProps> = ({
  size,
  type = 'Default',
  theme = 'Default',
  children,
  className,
  disabled,
  tooltipText,
  onClick,
  onMouseEnter,
}) => {
  const buttonClasses = classnames('controlContainer', className, styles[`size${size}`], {
    [styles.button]: true,
    [styles.disabled]: disabled,
    [styles.hoverable]: !disabled,
    [styles[`type${type}`]]: true,
    [styles[`theme${theme}`]]: true,
  });

  return (
    <button
      data-tooltip={tooltipText}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={onMouseEnter}
    >
      {children}
    </button>
  );
};

export default Button;
